/* Keycaps Office — cards v2 de colección (oct-2026).
   Reemplaza a ko-card-fit.js en las plantillas de colección.
   La foto de estudio (fondo blanco) ya llega recortada en el CDN a un
   cuadrado centrado (snippets/ko-card-studio-src.liquid). Aquí:
   1) medimos el keycap (lo que difiere del color de las esquinas) y
      escalamos para que mida ~60% del alto del tile, centrado;
   2) normalizamos el fondo a blanco (brightness) para que, con
      mix-blend-mode: multiply, todas las fotos tomen el MISMO color de tile
      aunque vengan con fondos de 200 a 255;
   3) pedimos al CDN la resolución que exige el zoom (sizes).
   Las medidas fallan con pelo blanco (se confunde con fondo): por eso la
   escala va acotada a [MIN_M, MAX_M] alrededor del recorte base, que por sí
   solo ya deja el keycap en ~40-55% del tile. */
(function () {
  'use strict';

  var TARGET_H = 0.54;  /* alto del keycap / alto del tile (borde suave + sombra suman ~5% a la vista) */
  var TARGET_W = 0.58;  /* ancho máximo */
  var MIN_M = 0.62;
  var MAX_M = 1.6;
  var SOFT_TOL = 30;    /* ~10 por canal: detalle de pelo blanco */
  var MAX_SHIFT = 0.04; /* corrección de centrado máx.: los renders ya vienen centrados y el pelo blanco descentra la medición */
  var SAMPLE = 96;
  var TOL = 96;
  var ROW_MIN = 2;

  var cache = {};
  var canvas, ctx;

  function cornerColor(d, w, h) {
    var offs = [[0, 0], [w - 3, 0], [0, h - 3], [w - 3, h - 3]];
    var r = 0, g = 0, b = 0, n = 0;
    for (var c = 0; c < 4; c++) {
      for (var y = offs[c][1]; y < offs[c][1] + 3; y++) {
        for (var x = offs[c][0]; x < offs[c][0] + 3; x++) {
          var i = (y * w + x) * 4;
          r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
        }
      }
    }
    return [r / n, g / n, b / n];
  }

  function diff(d, i, bg) {
    return Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]);
  }

  function analyze(img) {
    var key = img.currentSrc || img.src;
    if (!key) return null;
    if (key in cache) return cache[key];
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.width = SAMPLE; canvas.height = SAMPLE;
      ctx = canvas.getContext('2d', { willReadFrequently: true });
    }
    var w = SAMPLE, h = SAMPLE, d;
    try {
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      d = ctx.getImageData(0, 0, w, h).data;
    } catch (e) { cache[key] = null; return null; }

    var bg = cornerColor(d, w, h);
    var res = { bg: bg, light: (bg[0] + bg[1] + bg[2]) / 3 >= 170, box: null };
    if (!res.light) { cache[key] = res; return res; }

    var cols = [], rows = [], x, y;
    for (x = 0; x < w; x++) cols[x] = 0;
    for (y = 0; y < h; y++) rows[y] = 0;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        if (d[i + 3] <= 40 || diff(d, i, bg) <= TOL) continue;
        var mx = Math.max(d[i], d[i + 1], d[i + 2]);
        var mn = Math.min(d[i], d[i + 1], d[i + 2]);
        if (mx - mn < 20 && mx > 110) continue; /* sombra gris neutra */
        cols[x]++; rows[y]++;
      }
    }
    var minX = -1, maxX = -1, minY = -1, maxY = -1;
    for (x = 0; x < w; x++) if (cols[x] >= ROW_MIN) { if (minX < 0) minX = x; maxX = x; }
    for (y = 0; y < h; y++) if (rows[y] >= ROW_MIN) { if (minY < 0) minY = y; maxY = y; }
    if (maxX >= 0 && maxX - minX >= 4 && maxY - minY >= 4) {
      /* Pelo blanco/claro (Gojo, Jett, Killua...): el umbral fuerte lo
         confunde con el fondo y solo mide el cuerpo. Las sombras van en la
         base, así que extendemos HACIA ARRIBA con un umbral suave mientras
         haya filas con detalle sobre el cuerpo (tolerando 2 filas vacías). */
      var padX = Math.round((maxX - minX) * 0.25), gap = 0, x0, x1;
      x0 = Math.max(0, minX - padX); x1 = Math.min(w - 1, maxX + padX);
      for (y = minY - 1; y >= 0; y--) {
        var cnt = 0;
        for (x = x0; x <= x1; x++) if (diff(d, (y * w + x) * 4, bg) > SOFT_TOL) cnt++;
        if (cnt >= ROW_MIN) { minY = y; gap = 0; } else if (++gap > 2) break;
      }
      res.box = {
        bw: (maxX - minX + 1) / w, bh: (maxY - minY + 1) / h,
        cx: (minX + maxX + 1) / 2 / w, cy: (minY + maxY + 1) / 2 / h
      };
    }
    cache[key] = res;
    return res;
  }

  function fit(img) {
    if (!img.naturalWidth || img.naturalWidth < 40) return; /* con srcset es ancho / densidad */
    var studio = img.closest('.ko-studio');
    if (!studio) return;
    var frame = img.closest('.grid-view-item__image-wrapper');
    if (!frame) return;
    var fw = frame.clientWidth, fh = frame.clientHeight;
    if (!fw || !fh) return;

    var a = analyze(img);
    if (!a) return; /* sin CORS: quedan los valores base del CSS */
    if (!a.light) { studio.classList.add('ko-studio--dark'); return; }

    /* fondo → blanco: con multiply el tile queda del color del CSS */
    var bmax = Math.max(a.bg[0], a.bg[1], a.bg[2]);
    /* +3% sobre el blanco: borra parches casi blancos de composites (Gojo) */
    var bright = Math.max(1.03, Math.min(1.32, 262 / Math.max(bmax, 1)));
    img.style.setProperty('--ko-fit-b', bright.toFixed(3));

    var m = parseFloat(getComputedStyle(img).getPropertyValue('--ko-fit-s')) || 1.2;
    var tx = 0, ty = 0;
    if (a.box) {
      /* la imagen se dibuja object-fit: cover dentro del tile */
      var s = Math.max(fw / img.naturalWidth, fh / img.naturalHeight);
      var subjH = a.box.bh * img.naturalHeight * s / fh;
      var subjW = a.box.bw * img.naturalWidth * s / fw;
      m = Math.min(TARGET_H / subjH, TARGET_W / subjW);
      m = Math.max(MIN_M, Math.min(MAX_M, m));
      var dx = (a.box.cx - 0.5) * img.naturalWidth * s * m;
      var dy = (a.box.cy - 0.5) * img.naturalHeight * s * m;
      tx = Math.max(-fw * MAX_SHIFT, Math.min(fw * MAX_SHIFT, -dx));
      ty = Math.max(-fh * MAX_SHIFT, Math.min(fh * MAX_SHIFT, -dy));
    }
    img.style.setProperty('--ko-fit-s', m.toFixed(3));
    img.style.setProperty('--ko-fit-tx', tx.toFixed(1) + 'px');
    img.style.setProperty('--ko-fit-ty', ty.toFixed(1) + 'px');
    studio.classList.add('ko-studio--fit');

    /* resolución: el zoom no lo ve lazysizes (sizes = ancho sin escalar) */
    if (img.getAttribute('srcset') || img.getAttribute('data-srcset')) {
      var px = Math.ceil(fw * Math.max(1, m) * 1.05);
      var cur = parseInt(img.getAttribute('sizes'), 10);
      if (!cur || cur < px) {
        img.removeAttribute('data-sizes');
        img.setAttribute('sizes', px + 'px');
      }
    }
  }

  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (img.classList && img.classList.contains('grid-view-item__image')) fit(img);
  });

  /* cuando sizes sube y el navegador baja una versión mayor, re-medimos
     (el análisis queda en caché por URL, así que es barato) */
  document.addEventListener('load', function (e) {
    var img = e.target;
    if (img && img.classList && img.classList.contains('grid-view-item__image') &&
        img.closest && img.closest('.ko-cards-v2')) fit(img);
  }, true);

  function scan() {
    var imgs = document.querySelectorAll('.ko-cards-v2 .ko-studio .grid-view-item__image');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalWidth) fit(imgs[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT); rT = setTimeout(scan, 250);
  }, { passive: true });
})();
